// extracted by mini-css-extract-plugin
module.exports = {"delta-pro-ultra-launch":"Launch_delta-pro-ultra-launch__sCz11"};